import Footer from "../Footer/Footer";
import { useEffect , useState , useRef } from "react";
import { useLocation } from "react-router-dom";
import refund from "./refund.png"

function RefundPolicy() {
    
    const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  
  const [showButton, setShowButton] = useState(false);
    const clickTimeoutRef = useRef(null);

    // Show/hide button on scroll
    useEffect(() => {
        const handleScroll = () => {
            setShowButton(window.scrollY > 500);
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Scroll to hash target on load
    useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            setTimeout(() => {
                const target = document.querySelector(hash);
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                }
            }, 300);
        }
    }, []);

    // Click handler
    const handleClick = () => {
        if (clickTimeoutRef.current) {
            // Double click detected
            clearTimeout(clickTimeoutRef.current);
            clickTimeoutRef.current = null;
            window.scrollTo({ top: 0, behavior: 'smooth' });
        } else {
            // Wait to see if it's a double click
            clickTimeoutRef.current = setTimeout(() => {
                const target = document.querySelector('.other-privacy-content');
                if (target) {
                    target.scrollIntoView({ behavior: 'smooth' });
                }
                clickTimeoutRef.current = null;
            }, 300);
        }
    };


  return (
    <>
  <main className="container-fluid p-0">  

  <section className="legal-container">
            <div className="legal-wrapper">
                <div className="legal-content-section">
                    <h1 className="card-title-xl fw-l">Refund Policy</h1>
                    <p className="paragraph-md text-balance">
                        Our payment website strives to provide a seamless and hassle-free payment experience to our customers. If you are not satisfied with your payment transaction, we offer refunds under certain circumstances.
                    </p>
                </div>
                <div className="legal-image-container">
                    <img src={refund} alt="" style={{aspectRatio:"16/8"}}/>
                </div>
            </div>
        </section>
        
        <section className="privacy-section mb-3" id="">
            <div className="other-privacy-content">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card" id="">
                        <h2  className="paragraph-xs"> Eligibility for Refund:</h2>
                            <ul className="xsmall ps-4 mb-0">
                                <li>If the payment was made by mistake</li>
                                <li>If the payment was not for the intended purpose</li>
                                <li>If the payment was for a duplicate transaction <br/>
                                    All refunds will be initiated after 15 days from the date of transaction after the request is received and approved.
                                    Please call us our customer service number - (855) 880-4791 and provide a confirmation that you will not request for
                                    a stop payment or chargeback with your bank. <br/>
                                    You may also request a refund via email to customerservice@credencerm.com with the following information:
                                </li>
                                <li>Your name and contact information</li>
                                <li>Your Credence Account number</li>
                                <li>Transaction ID</li>
                                <li>Reason for the refund request</li>
                                <li>
                                    Confirmation that you will not request for a stop payment or chargeback with your bank <br/> The refund will be credited to the original payment method <br/>
                                    If we are unable to refund to the original source account, then the refund will be initiated via a check in the mail. Refund checks issued by Credence should be cashed by you within a period of 6 months from the check issue date <br/>

                                    <strong>Please note that the refund policy is subject to change at any time, and it is your responsibility to regularly check this page for updates.</strong>
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
                
             </div>        
        </section>
    </main>
    <button
            id="scrollToTopBtn"
            className="scrollTopButton"
            style={{ display: showButton ? 'block' : 'none' }}
            onClick={handleClick}
        >
            <i className="bx bx-chevron-up"></i>
        </button>
    </>
  );
}

export default RefundPolicy;
